import "./APIPayload";
import DBG from "./DBG";
import ProjSettings from "./model/ProjSettings";
export class APIHelper {
    static GetProjectSettings(projectGuid) {
        DBG.log("ApiHelper - GetProjectSettings: ", projectGuid);
        let payload = {
            op: "GetProjectSettings",
            guid: projectGuid
        };
        let settings = new ProjSettings(projectGuid);
        let res = this.apiPost("tableStor", payload);
        return res;
    }
    static SetProjectSettings(projSettings) {
        DBG.log("ApiHelper - SetProjectSettings: ", projSettings);
        let payload = {
            op: "SetProjectSettings",
            settings: projSettings
        };
        let res = this.apiPost("tableStor", payload);
        return res;
    }
    static callAPI(func, name) {
        const promise = new Promise((resolve, reject) => {
            fetch(`${this.baseURL}/tableStor`, {
                method: 'POST',
                mode: 'cors',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'text/plain; charset=utf-8' },
            }).then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                DBG.log("doGet SUCCESS:");
                return response.text();
            }).then(data => {
                DBG.log("doGet SUCCESS:");
                DBG.log(data);
                resolve(data);
            }).catch((err) => {
                reject(err);
            });
        });
        return promise;
    }
    static getAuthInfo() {
        const promise = new Promise((resolve, reject) => {
            fetch('/.auth/me').then(resp => {
                resp.json().then(data => {
                    resolve(data);
                }).catch(reason => reject(reason));
            }).catch(reason => reject(reason));
        });
        return promise;
    }
    static getUserFromAPI() {
        let payload = {
            op: "get_auth_user"
        };
        let promise = this.apiPost("apiEntry", payload);
        return promise;
    }
    static callApiEntry(payload) {
        let promise = this.apiPost("apiEntry", payload);
        return promise;
    }
    static createUser(email, name, licence, company) {
        let expDate = new Date();
        switch (licence) {
            case "YearlySingle":
            case "YearlyThree":
                expDate.setFullYear(expDate.getFullYear() + 1);
                break;
            case "MonthlySingle":
            case "MonthlyThree":
                expDate.setMonth(expDate.getMonth() + 1);
                break;
        }
        let payload = {
            op: "create_user",
            user: email,
            name: name,
            licence: licence,
            company: company,
            expiry: expDate
        };
        let promise = this.apiPost("apiEntry", payload);
        return promise;
    }
    static apiPost(method, payload) {
        DBG.log("APIHelper - apiPost", method, payload);
        const promise = new Promise((resolve, reject) => {
            fetch(`${this.baseURL}/${method}`, {
                method: 'POST',
                mode: 'cors',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'text/plain; charset=utf-8' },
                body: JSON.stringify(payload),
            }).then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                DBG.log("APIHelper - apiPost SUCCESS:", response);
                return response.json();
            }).then(data => {
                DBG.log("APIHelper - apiPost SUCCESS:", data);
                if (data) {
                    resolve(data);
                }
                else {
                    reject("Not found");
                }
            }).catch((err) => {
                reject(err);
            });
        });
        return promise;
    }
    static logOut() {
        let payload = {
            op: "log_out"
        };
        let promise = this.apiPost("apiEntry", payload);
        return promise;
    }
}
APIHelper.APIKEY = "";
APIHelper.baseURL = `/api`;
